import React from "react";

interface Props {
  data: string | number;
  className?: string;
}

export const AgePill = ({ data, className = "" }: Props) => {
  return (
    <>
      {data && (
        <div
          className={`inline-flex h-9  shrink-0 items-center justify-center rounded-xl border border-green-200 bg-green-50 px-2 ${className}`}
        >
          <span className="whitespace-nowrap text-[13px] font-semibold text-green-700">{data}</span>
        </div>
      )}
    </>
  );
};

export default AgePill;
